<template>
	<w-dialog
		:model-value="showDialog"
		:title="type == 'new' ? 'Add Shairi' : 'Edit Shairi'"
		title-class="bg-main white"
		transition="slide-down"
		persistent="persistent"
		:fullscreen="false"
		:persistent-no-animation="false"
		:width="700"
		style="position:fixed;"
	>
		<w-alert error plain v-if="dialogError"
			><p>
				Fail To {{ type == 'new' ? 'Add' : 'Change' }} Shairi
			</p></w-alert
		>
		<w-alert success plain v-if="dialogSuccess"
			><p>
				Shairi {{ type == 'new' ? 'Added' : 'Changed' }} Successful !!!
			</p></w-alert
		>
		<w-form
			action="#"
			method="post"
			@submit.prevent="addShairi()"
			class="mt2"
		>
			<w-input
				outline="outline"
				placeholder="Shairi Title"
				color="text-main"
				inner-icon-left="mdi mdi-account"
				v-model="title"
				:validators="[validators.required]"
			/>
			<!-- <w-input
				outline="outline"
				Placeholder="Shairi detail"
				color="text-main"
				class="mt4"
				inner-icon-left="mdi mdi-file"
				v-model="detail"
				:validators="[validators.required]"
			/> -->

			<div class="mt3">
				<quill-editor v-model:content="detail" contentType="html" placeholder="Andika jibu hapa" class="" theme="snow"  toolbar="essential"></quill-editor>
			</div>
			
						
			

			<w-flex class="mt6 text-center">
				<w-button class="" @click="$emit('closed')" bg-color="error"
					>Close</w-button
				>
				<w-button
					v-if="type == 'new'"
					type="submit"
					class="ml5 bg-main"
					bg-color="teal"
					color="white"
					:loading="isLoading"
					>SAVE</w-button
				>
				<w-button
					v-if="type == 'edit'"
					type="submit"
					class="ml5 bg-main"
					bg-color="teal"
					color="white"
					:loading="isLoading"
					>UPDATE</w-button
				>
			</w-flex>
		</w-form>
	</w-dialog>
</template>
<script>
import axios from 'axios';
export default {
	props: {
		showDialog: {
			type: Boolean,
			required: true,
			validators: function(value) {
				return value === true || value === false;
			},
		},
		content: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			type: 'new',
			id: null,
			title: '',
			detail: '',
			isLoading: false,
			shairiContent:'',
			validators: {
				required: (value) => !!value || 'This field is required',
			},
			dialogError: false,
			dialogSuccess: false,
		};
	},
	methods: {
		addShairi() {
			if (
				this.title != '' &&
				this.detail != ''
			) {
			
				this.isLoading = true;
				let formData = new FormData();
				formData.append(
					'status',
					this.type == 'new' ? 0 : 1
				);
				formData.append('mashairiId', this.id??0);
				formData.append('title', this.title);
				formData.append('details', this.detail);

		
	
				axios
					.post('mashairi.php', formData)
					.then((data) => {
						this.isLoading = false;
						let result = data.data;
						if (result.status == 200) {
							this.$emit('load-data', data.data);
							this.dialogError = false;
							this.dialogSuccess = true;
						} else {
							this.dialogError = true;
							this.dialogSuccess = false;
						}
					})
					.catch((error) => {
						this.isLoading = false;
						alert(error);
					});
			}
		},
	},
	watch: {
		showDialog() {
			this.dialogSuccess = false;
			this.dialogError = false;
			let shairi = this.content;
			this.id = shairi.id;
			this.type = shairi.type;
			this.title = shairi.title
			this.detail = shairi.detail
		},
	}
};
</script>
<style scoped></style>
